import type { SettableOfferRequestReportStatus } from '@houzy/schemas/offer-request-management';
import {
    type PartnerCockpitContactDetail,
    type PartnerCockpitOfferRequestDetail,
    type PartnerCockpitRevealContactDetailInput,
    partnerCockpitOfferRequestDetailSchema,
    type RecordOfferRequestOpeningResult,
    recordOfferRequestOpeningResultSchema,
} from '@houzy/schemas/partner-cockpit/offer-requests';

import { apiRequest } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';

export async function fetchOfferRequestDetail(
    offerRequestLeadUuid: string,
    signal?: AbortSignal,
): Promise<PartnerCockpitOfferRequestDetail> {
    return apiRequest(partnerCockpitApiPath(`offer-requests/${offerRequestLeadUuid}`), {
        signal,
        responseSchema: partnerCockpitOfferRequestDetailSchema,
    });
}

// The details GET is prefetched on hover, so the opening is recorded by its own call from the details page.
export async function recordOfferRequestOpening(
    offerRequestLeadUuid: string,
): Promise<RecordOfferRequestOpeningResult> {
    return apiRequest(partnerCockpitApiPath(`offer-requests/${offerRequestLeadUuid}/openings`), {
        method: 'POST',
        responseSchema: recordOfferRequestOpeningResultSchema,
    });
}

export async function revealOfferRequestContactDetail(
    offerRequestLeadUuid: string,
    detail: PartnerCockpitContactDetail,
): Promise<void> {
    const body: PartnerCockpitRevealContactDetailInput = { detail };
    await apiRequest(partnerCockpitApiPath(`offer-requests/${offerRequestLeadUuid}/contact-reveals`), {
        method: 'POST',
        body,
    });
}

export async function updateOfferRequestStatus(
    offerRequestLeadUuid: string,
    status: SettableOfferRequestReportStatus,
): Promise<void> {
    await apiRequest(partnerCockpitApiPath(`offer-requests/${offerRequestLeadUuid}/status`), {
        method: 'PATCH',
        body: { status },
    });
}
